// extracted by mini-css-extract-plugin
export default {"section4":"Section4_section4__KTwfq","card":"Section4_card__Ft8te","title":"Section4_title__Wswao","tagLine":"Section4_tagLine__SMjSS","text":"Section4_text__bJvmA"};